import { CircularProgress, Stack, Typography } from '@mui/material';

export default function LoadingIndicator({ label = 'Daten werden geladen …', compact = false, sx }) {
  return <Stack role="status" aria-label={label} aria-live="polite" direction="row" spacing={1.25}
    alignItems="center" sx={{ py: compact ? 0.5 : 2, ...sx }}>
    <CircularProgress size={compact ? 18 : 24} color="primary" aria-hidden="true" />
    <Typography variant={compact ? 'caption' : 'body2'}>{label}</Typography>
  </Stack>;
}
